// Centralised options for the multi-step QuoteForm.

export const SERVICE_OPTIONS = [
    { id: "fencing", label: "Fencing", icon: "Fence" },
    { id: "interlocking", label: "Interlocking & Paving", icon: "Grid3x3" },
    { id: "decking", label: "Decking", icon: "Layers" },
    { id: "concrete", label: "Concrete & Asphalt", icon: "Construction" },
    { id: "landscaping", label: "Landscaping", icon: "Trees" },
    { id: "renovations", label: "Interior Renovations", icon: "Home" },
    { id: "other", label: "Other / Not sure yet", icon: "HelpCircle" },
];

export const PROPERTY_TYPES = [
    { id: "residential", label: "Residential" },
    { id: "commercial", label: "Commercial" },
];

// --- Track-specific quote options (Commercial / Industrial) ---

export const COMMERCIAL_SERVICE_OPTIONS = [
    { id: "commercial-fencing-gates", label: "Fencing & Gates", icon: "Fence" },
    { id: "parking-lots-asphalt", label: "Parking Lots & Asphalt", icon: "Construction" },
    { id: "concrete-sidewalks", label: "Concrete & Sidewalks", icon: "Construction" },
    { id: "interlocking-hardscape", label: "Interlocking & Hardscape", icon: "Grid3x3" },
    { id: "commercial-masonry-restoration", label: "Masonry & Restoration", icon: "Layers" },
    { id: "landscaping-grounds", label: "Landscaping & Grounds", icon: "Trees" },
    { id: "snow-ice-management", label: "Snow & Ice Management", icon: "HelpCircle" },
    { id: "exterior-renovations-buildouts", label: "Exterior Build-Outs", icon: "Home" },
    { id: "other", label: "Other / Not sure yet", icon: "HelpCircle" },
];

export const INDUSTRIAL_SERVICE_OPTIONS = [
    { id: "heavy-duty-asphalt-paving", label: "Heavy-Duty Asphalt", icon: "Construction" },
    { id: "industrial-concrete", label: "Industrial Concrete", icon: "Construction" },
    { id: "site-security-fencing", label: "Security Fencing", icon: "Fence" },
    { id: "industrial-masonry-structural", label: "Masonry & Structural", icon: "Layers" },
    { id: "retaining-walls-site-works", label: "Retaining Walls & Site Works", icon: "Grid3x3" },
    { id: "bollards-guard-rails-safety", label: "Bollards & Traffic Safety", icon: "Construction" },
    { id: "exterior-grounds-drainage", label: "Grounds & Drainage", icon: "Trees" },
    { id: "snow-ice-management-industrial", label: "Snow & Ice Management", icon: "HelpCircle" },
    { id: "other", label: "Other / Not sure yet", icon: "HelpCircle" },
];

export const COMMERCIAL_PROPERTY_TYPES = [
    { id: "retail", label: "Retail" },
    { id: "office", label: "Office" },
    { id: "industrial-commercial", label: "Industrial / Commercial" },
    { id: "multi-residential", label: "Multi-Residential" },
    { id: "mixed-use", label: "Mixed-Use" },
    { id: "other", label: "Other" },
];

export const INDUSTRIAL_PROPERTY_TYPES = [
    { id: "warehouse", label: "Warehouse / DC" },
    { id: "manufacturing", label: "Manufacturing / Plant" },
    { id: "logistics", label: "Logistics / Yard" },
    { id: "industrial-park", label: "Industrial Park" },
    { id: "other", label: "Other" },
];

// Extra B2B fields (shown on commercial/industrial contact forms only).
export const NUM_SITES = [
    { id: "single", label: "Single site" },
    { id: "2-5", label: "2 – 5 sites" },
    { id: "6-plus", label: "6+ sites" },
];

export const ROLES = [
    { id: "owner", label: "Owner" },
    { id: "developer", label: "Developer" },
    { id: "property-manager", label: "Property Manager" },
    { id: "facility-manager", label: "Facility Manager" },
    { id: "other", label: "Other" },
];

// Resolve the quote-form option set for a given track.
export function getTrackQuoteConfig(track) {
    if (track === "commercial") {
        return {
            serviceOptions: COMMERCIAL_SERVICE_OPTIONS,
            propertyTypes: COMMERCIAL_PROPERTY_TYPES,
            isB2B: true,
        };
    }
    if (track === "industrial") {
        return {
            serviceOptions: INDUSTRIAL_SERVICE_OPTIONS,
            propertyTypes: INDUSTRIAL_PROPERTY_TYPES,
            isB2B: true,
        };
    }
    return { serviceOptions: SERVICE_OPTIONS, propertyTypes: PROPERTY_TYPES, isB2B: false };
}

export const PROJECT_SIZES = [
    { id: "small", label: "Small", sub: "Under $5K" },
    { id: "medium", label: "Medium", sub: "$5K – $15K" },
    { id: "large", label: "Large", sub: "$15K – $50K" },
    { id: "premium", label: "Premium", sub: "$50K+" },
    { id: "unsure", label: "Not sure", sub: "We'll help you scope it" },
];

export const TIMELINES = [
    { id: "asap", label: "ASAP" },
    { id: "1-3-months", label: "1 – 3 months" },
    { id: "3-6-months", label: "3 – 6 months" },
    { id: "6-plus-months", label: "6+ months" },
    { id: "exploring", label: "Just exploring" },
];

export const BEST_TIMES = [
    { id: "morning", label: "Morning" },
    { id: "afternoon", label: "Afternoon" },
    { id: "evening", label: "Evening" },
    { id: "anytime", label: "Anytime" },
];

export const REFERRAL_SOURCES = [
    "Google",
    "Friend or Family",
    "Homestars",
    "BBB",
    "Bark",
    "Houzz",
    "Instagram",
    "Facebook",
    "Other",
];

export const QUOTE_API_PATH = "/api/quote-submission";

export const ADMIN_TOKEN_STORAGE_KEY = "reformity_admin_token";
